import React from 'react'

import { Button, CircularProgress, createStyles, Theme } from '@mui/material'
import { ButtonProps } from '@mui/material/Button'
import { withStyles, WithStyles } from '@mui/styles'

const SubmitButton: React.SFC<SubmitButtonProps & WithStyles<typeof styles>> = ({
  classes,
  label = 'Submit',
  submitting = false,
  ...buttonProps
}) => {
  return (
    <Button color="secondary" variant="contained" size="medium" type="submit" disabled={submitting} {...buttonProps}>
      {label}
      {submitting && <CircularProgress size={24} className={classes.submitProgress} />}
    </Button>
  )
}

export type SubmitButtonProps = ButtonProps & {
  submitting?: boolean
  label?: string
}

const styles = ({ palette }: Theme) =>
  createStyles({
    submitProgress: {
      color: palette.secondary.main,
      position: 'absolute',
    },
  })

export default withStyles(styles)(SubmitButton)
